import { DynamicGalleryRepository } from '@aipb/gulliver/dynamic-gallery/data-access';
import { Pagination, RecordContent } from '@aipb/gulliver/dynamic-gallery/model';
import { ImagePreviewItem } from '@aipb/gulliver/image-preview';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'dg-record-open-layers',
  templateUrl: './record-open-layers.component.html',
  styleUrls: ['./record-open-layers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecordOpenLayersComponent {
  @Input() activeRecordId: string;
  @Input() pagination?: Pagination;
  prevIcon = faChevronLeft;
  nextIcon = faChevronRight;
  private dynamicGalleryRepository = inject(DynamicGalleryRepository);
  castorUrl$ = this.dynamicGalleryRepository.castorUrl$;
  coreId$ = this.dynamicGalleryRepository.coreId$;

  private _imageItems: ImagePreviewItem[] = [];

  get imageItems() {
    return this._imageItems;
  }

  private _items: RecordContent[] = [];

  @Input() set items(value: RecordContent[]) {
    this._items = value;

    this._imageItems = value.map((record) => {
      const original = record.images[0].main;
      const thumb = record.images3if ? record.images3if[0] + 'full/,150/0/default.jpg' : record.images[0].thumb;

      return {
        id: record.id,
        sublabel: record.sublabel,
        description: record.description,
        original,
        thumb,
        tags: record.tags,
        html: record.html
      };
    });
  }

  get activeRecord() {
    return this._imageItems.find((i) => i.id === this.activeRecordId);
  }

  getActiveRecordId(): string {
    const activeRecord = this.activeRecord;

    return activeRecord ? activeRecord.id : null;
  }

  onDetail(item: ImagePreviewItem) {
    this.dynamicGalleryRepository.setActiveRecordId(item.id);
  }
}
